import { ObjectFieldTemplateProps } from "@rjsf/utils";

function MultidimensionalCustomFormTemplate(props: ObjectFieldTemplateProps) {
  let colsSchemas = props.uiSchema?.colsSchema;

  return (
    <>
      {colsSchemas ? (
        <div className="row">
          {colsSchemas.map((column: any, columnIndex: any) => (
            <div className={column.cols} key={columnIndex}>
              <div className="row">
                {column.elements.map((row: any, rowIndex: any) => (
                  <div className="row" key={rowIndex}>
                    {row.map((element: any, elementIndex: any) => (
                      <div className={element.cols} key={elementIndex}>
                        <div className="property-wrapper m-0">
                          {getPropertyByName(element.name, props)?.content}
                        </div>
                      </div>
                    ))}
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      ) : (
        <>
          <div>
            {props.title}
            {props.description}
            {props.properties.map((element) => (
              <div className="property-wrapper" key={element.name}>
                {element.content}
              </div>
            ))}
          </div>
        </>
      )}
    </>
  );

  function getPropertyByName(name: string, props: ObjectFieldTemplateProps) {
    let element = props.properties.find((element: any) => element.name == name);
    // console.log(element);
    return element;
  }
}
export default MultidimensionalCustomFormTemplate;